import { setIsLoading } from '../../../../../actions/general';
import { callApi } from '../../../../../apiCaller';
import { toastError } from '../../../../../utils';
import { API_SYSTEM_ADMIN_SURVEY } from '../actions';

export const SET_ADMIN_SURVEY_DETAILS = 'setAdminSurveyDetails';
export const ADD_ADMIN_SURVEY_SECTION = 'addAdminSurveySection';
export const UPDATE_ADMIN_SURVEY_SECTION = 'updateAdminSurveySection';
export const DELETE_ADMIN_SURVEY_SECTION = 'deleteAdminSurveySection';

export const SET_ADMIN_SURVEY_QUESTIONS = 'setAdminSurveyQuestions';
export const ADD_ADMIN_SURVEY_QUESTION = 'addAdminSurveyQuestion';
export const UPDATE_ADMIN_SURVEY_QUESTION = 'updateAdminSurveyQuestion';
export const DELETE_ADMIN_SURVEY_QUESTION = 'deleteAdminSurveyQuestion';

export const DELETE_ADMIN_QUESTION_USER_SURVEY_RESULT = 'deleteAdminQuestionUserSurveyResult';

// Product Details
export const setAdminSurveyDetails = (surveyDetails) => {
     return {
          type: SET_ADMIN_SURVEY_DETAILS,
          payload: surveyDetails,
     };
};

export const fetchAdminSurveyDetailsRequest = (surveyId) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SYSTEM_ADMIN_SURVEY.replace(':id', surveyId), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               dispatch(setAdminSurveyDetails(response.data));
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

// Survey Section
export const addAdminSurveySection = (surveySection) => {
     return {
          type: ADD_ADMIN_SURVEY_SECTION,
          payload: surveySection,
     };
};

export const updateAdminSurveySection = (surveySection) => {
     return {
          type: UPDATE_ADMIN_SURVEY_SECTION,
          payload: surveySection,
     };
};

export const deleteAdminSurveySection = (surveySectionId) => {
     return {
          type: DELETE_ADMIN_SURVEY_SECTION,
          payload: surveySectionId,
     };
};

// Survey Question
export const setAdminSurveyQuestions = (surveyQuestions) => {
     return {
          type: SET_ADMIN_SURVEY_QUESTIONS,
          payload: surveyQuestions,
     };
};

export const addAdminSurveyQuestion = (surveyQuestion) => {
     return {
          type: ADD_ADMIN_SURVEY_QUESTION,
          payload: surveyQuestion,
     };
};

export const updateAdminSurveyQuestion = (surveyQuestion) => {
     return {
          type: UPDATE_ADMIN_SURVEY_QUESTION,
          payload: surveyQuestion,
     };
};

export const deleteAdminSurveyQuestion = (surveyQuestionId) => {
     return {
          type: DELETE_ADMIN_SURVEY_QUESTION,
          payload: surveyQuestionId,
     };
};

// User Survey Result
export const deleteAdminQuestionUserSurveyResult = (surveyQuestionId) => {
     return {
          type: DELETE_ADMIN_QUESTION_USER_SURVEY_RESULT,
          payload: surveyQuestionId,
     };
};
